import {Fragment, useState} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, Table} from 'semantic-ui-react';
import moment from 'moment-jalaali';
import {ConfirmModal} from '../shared/modals';
import {deleteReport} from '../../redux/actions/report';
import {getTypeText as _} from '../../utils/homeworks';

function ReportsList(props) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState(0);

  function handleDelete(reportId) {
    setSelectedReportId(reportId);
    setShowConfirmModal(true);
  }

  function handleConfirm() {
    props.deleteReport(selectedReportId);
    setSelectedReportId(0);
    setShowConfirmModal(false);
  }

  function handleCancel() {
    setSelectedReportId(0);
    setShowConfirmModal(false);
  }

  return (
    <Fragment>
      <Table fixed striped unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>تاریخ انجام</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>تکالیف</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>مدت زمان انجام</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>عملیات</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {props.reports.map(report => {
            const isDeletable = moment().diff(moment(report.date), 'days') < 4;

            return (
              <Table.Row key={report.id}>
                <Table.Cell textAlign='center'>
                  <p>{moment(report.date).format('dddd')}</p>
                  <p>{moment(report.date).format('jYY/jMM/jDD')}</p>
                </Table.Cell>
                <Table.Cell textAlign='center'>
                  {report.homeworks.map(homework => (
                    <p key={homework.id}>{`${homework.name} (${_(homework.type)})`}</p>
                  ))}
                </Table.Cell>
                <Table.Cell textAlign='center'>
                  {report.duration.replace(/:[^:]*$/, '')}
                </Table.Cell>
                <Table.Cell textAlign='center'>
                  {isDeletable && (
                    <Button
                      basic
                      icon='trash alternate'
                      color='red'
                      size='mini'
                      onClick={handleDelete.bind(null, report.id)}
                    />
                  )}
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={4}>
              <Button
                primary
                as={Link}
                to='/report'
                floated='right'
                size='small'
                content={'ثبت گزارش جدید'}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      <ConfirmModal
        open={showConfirmModal}
        content='آیا از پاک کردن این گزارش مطمئنید؟'
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </Fragment>
  );
}

ReportsList.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.object)
};

export default connect(null, {deleteReport})(ReportsList);
